import React, { useState, useEffect } from "react";
import { Row, Col, Form, Modal, Typography, Input, Button, Divider, Spin, notification } from "antd";
import { ExclamationCircleOutlined, SearchOutlined, ArrowLeftOutlined, PlusOutlined, ArrowRightOutlined, UserOutlined } from "@ant-design/icons";

import api from "../../../services/api";
import CpfCnpj from "@react-br-forms/cpf-cnpj-mask";
import InputCep from "../../inputCep";
import TabelaDados from "../../tabelaDados";
import DrawerCliente from "../../drawerCliente";
import { MaskFormat } from "../../../ValueObjects";
import { useStateValue } from '../../../state';
import { drawerActions, listagemActions, manutencaoActions } from "../../../actions";
import { retornaSoNumeros, validarCpf, validarCnpj, consultaCNPJ } from "../../../services/funcoes";

export default function ModalBuscaCliente({ setDadosCliente, exibirModalBuscaCliente, fecharModalBuscaCliente }) {

    const [form] = Form.useForm();
    const [{ manutencao }, dispatch] = useStateValue();
    const [cpfCnpj, setCpfCnpj] = useState(null);
    const [editando, setEditando] = useState(false);
    const [carregandoBusca, setCarregandoBusca] = useState(false);
    const [consultaCliente, setConsultaCliente] = useState(false);
    const [dadosTempCliente, setDadosTempCliente] = useState({});

    const onCloseModal = () => {
        Modal.confirm({
            title: 'Cancelar?',
            icon: <ExclamationCircleOutlined />,
            content: 'Deseja cancelar a operação?',
            okText: 'Sim',
            cancelText: 'Não',
            centered: true,
            onOk() {
                form.resetFields();
                setConsultaCliente(false);
                setCpfCnpj(null);
                fecharModalBuscaCliente();
            }
        });
    };

    useEffect(() => {
        setTimeout(() => {
            try {
                let element = document.getElementById("cpf");
                if (element) {
                    element.focus();
                }
            } catch (error) {
                console.log('error :>> ', error);
            }
        });

        if (exibirModalBuscaCliente && manutencao.dados?.cliente?.dadosForm?.[0]) {
            let cliente = manutencao.dados?.cliente;
            setDadosTempCliente(cliente)
            form.setFieldsValue(cliente?.dadosForm[0]);
        }
    }, [exibirModalBuscaCliente]);

    useEffect(() => {
        if (manutencao.voltaVenda) {
            if (!!manutencao.dados && !!manutencao.dados.clienteDados) {
                adicionarCliente(manutencao.dados.clienteDados);
            }
        }
    }, [manutencao.voltaVenda]);

    useEffect(() => {
        if (!exibirModalBuscaCliente) return;

        window.addEventListener('keydown', handleKeyPress);
        return () => {
            window.removeEventListener('keydown', handleKeyPress);
        }
    }, [exibirModalBuscaCliente, dadosTempCliente])

    const handleKeyPress = (event) => {
        const elementoAtivo = document.activeElement;
        if (event.code === 'Enter') {
            if (elementoAtivo?.closest('.ant-modal-confirm')) return;
            if (elementoAtivo?.closest('.ant-drawer')) return;
            if (elementoAtivo?.id === 'cpf') return;
            if (elementoAtivo?.closest('.ant-input-search')) return;

            event.preventDefault();
            adicionarCliente();
        }
    }

    async function buscarCliente() {
        let dados = form.getFieldsValue();
        const valorPesquisa = dados.cpfCnpj?.trim() || dados.pes_nome?.trim() || '';

        form.setFieldsValue({ pesquisa: valorPesquisa });

        setConsultaCliente(true);
        dispararPesquisa(valorPesquisa);
    }

    function dispararPesquisa(value) {
        dispatch({ type: listagemActions.CHANGE, data: { campoFiltro: 'Filtro', filtro: `${value}`, ordem: '+pes_nome' } });
    }

    async function buscarClienteCpfCnpj() {
        let dados = form.getFieldsValue();
        if (!!dados.cpfCnpj) {
            setCarregandoBusca(true);
            dados.cpfCnpj = retornaSoNumeros(dados.cpfCnpj);
            let _cpfCnpjValid = false;
            if (dados.cpfCnpj.length === 11) _cpfCnpjValid = validarCpf(dados.cpfCnpj)
            if (dados.cpfCnpj.length === 14) _cpfCnpjValid = validarCnpj(dados.cpfCnpj)
            if (_cpfCnpjValid) {
                api.get(`Cliente/BuscarClienteCpfCnpj/${dados.cpfCnpj}`).then(
                    res => {
                        if (!!res.data) {
                            notification.success({ message: 'Aviso!', description: 'Cliente já cadastrado' });
                            let dados = res.data;
                            let endereco = dados.enderecos.find(item => item.pee_enderecoprincipal);
                            form.setFieldsValue({
                                pes_nome: dados.pes_nome
                            });

                            if (endereco) {
                                form.setFieldsValue({
                                    pej_inscricaoestadual: dados.pej_inscricaoestadual ?? endereco.pie_inscricaoestadual,
                                    cep_cep: endereco.cep_cep,
                                    cid_descricao: endereco.cid_descricao,
                                    est_sigla: endereco.est_sigla,
                                    log_logradouro: endereco.log_logradouro,
                                    pee_numero: endereco.pee_numero,
                                    bai_nome: endereco.bai_nome
                                });
                            }

                            setDadosTempCliente(dados);
                        }
                    }
                ).catch(
                    (erro) => {
                        console.log(erro);
                        setDadosTempCliente({})
                        setDadosCliente({});
                        if (dados.cpfCnpj.length === 14) {
                            consultaCNPJ(dados.cpfCnpj).then((json) => {
                                form.setFieldsValue({
                                    pes_nome: json.nome,
                                    cep_cep: json.cep,
                                    cid_descricao: json.municipio,
                                    est_sigla: json.uf,
                                    log_logradouro: json.logradouro,
                                    pee_numero: json.numero,
                                    bai_nome: json.bairro
                                });
                            }, (erro) => {
                                console.log('ERRO:', erro);
                            });
                        }
                    }
                ).finally(() => {
                    setCarregandoBusca(false);
                });
            } else {
                setCarregandoBusca(false);
                Modal.warning({
                    title: 'Aviso!',
                    content: `CPF/CNPJ inválido ! `,
                    centered: true,
                    onOk() {
                        form.resetFields();
                        setCpfCnpj(null);
                    }
                })
            }
        }
    }

    async function buscarClienteId(dados) {
        let pesId = dados.pes_id;
        if (pesId) {
            api.get(`Cliente/BuscarByIdPessoa/${pesId}`).then(
                res => {
                    if (!!res.data) {
                        let dados = res.data;
                        let endereco = dados.enderecos.find(item => item.pee_enderecoprincipal);
                        form.setFieldsValue({
                            cpfCnpj: dados.pef_cpf || dados.pej_cnpj,
                            pes_nome: dados.pes_nome
                        });

                        if (endereco) {
                            form.setFieldsValue({
                                pej_inscricaoestadual: dados.pej_inscricaoestadual || endereco.pie_inscricaoestadual,
                                cep_cep: endereco.cep_cep,
                                cid_descricao: endereco.cid_descricao,
                                est_sigla: endereco.est_sigla,
                                log_logradouro: endereco.log_logradouro,
                                pee_numero: endereco.pee_numero,
                                bai_nome: endereco.bai_nome
                            });
                        }
                        
                        setDadosTempCliente(dados);
                    }
                }
            ).catch(
                (erro) => {
                    console.log(erro);
                    setDadosTempCliente({})
                    setDadosCliente({});
                    notification.warning({ message: 'Atenção!', description: 'Erro ao carregar dados do Cliente' });
                }
            );
        }
        else {
            notification.warning({ message: 'Atenção!', description: 'Erro ao carregar dados do Cliente' });
        }
    }

    function verificaCep(cep) {
        cep = retornaSoNumeros(cep);
        if (cep.length === 8) {
            api.get(`Cidade/BuscaCidadeCep?cep=${cep}`).then(
                (res) => {
                    if (res.status === 200 && res.data.length > 0) {
                        form.setFieldsValue({
                            cid_descricao: res.data.length > 0 ? res.data[0].cid_descricao : '',
                            est_sigla: res.data.length > 0 ? res.data[0].est_sigla : ''
                        })
                    } else {
                        notification.warning({ message: 'Aviso!', description: 'CEP não encontrado' });
                        form.setFieldsValue({ cep_cep: undefined });
                    }
                }
            ).catch((error) => {
                notification.warning({ message: 'Aviso!', description: 'Erro ao buscar o CEP' });
                form.setFieldsValue({ cep_cep: undefined });
            })
        } else {
            notification.warning({ message: 'Atenção!', description: 'Informe o CEP' });
            form.setFieldsValue({ cep_cep: undefined });
        }
    }

    async function selecionarCliente(dados) {
        let cpfCnpj = !!dados.pef_cpf ? dados.pef_cpf : !!dados.pej_cnpj ? dados.pej_cnpj : dados.pes_idestrangeiro;
        let ret = {}
        if (!!dados.pes_id) {
            ret = await api.get(`Cliente/BuscarByIdPessoa/${dados.pes_id}`);
        } else if (!!cpfCnpj) {
            ret = await api.get(`Cliente/BuscarClienteCpfCnpj/${retornaSoNumeros(cpfCnpj)}`);
        } else {
            return;
        }

        let cliente = ret.data;
        let endereco = cliente.enderecos.find(item => item.pee_enderecoprincipal);
        form.setFieldsValue({
            cpfCnpj: cpfCnpj || '',
            pes_nome: cliente.pes_nome
        });

        if (endereco) {
            form.setFieldsValue({
                pej_inscricaoestadual: cliente.pej_inscricaoestadual ?? endereco.pie_inscricaoestadual,
                cep_cep: endereco.cep_cep,
                cid_descricao: endereco.cid_descricao,
                est_sigla: endereco.est_sigla,
                log_logradouro: endereco.log_logradouro,
                pee_numero: endereco.pee_numero,
                bai_nome: endereco.bai_nome
            });
        }

        setDadosTempCliente(cliente);
        setConsultaCliente(false);
    }

    async function adicionarCliente() {
        const dadosForm = form.getFieldsValue();

        if (!dadosForm.cpfCnpj) {
            notification.warning({ message: 'Atenção!', description: 'Informe o CPF ou CNPJ' });
            return;
        }

        if (dadosForm.cpfCnpj.length > 14) {
            if (!dadosForm.cep_cep || !dadosForm.cid_descricao || !dadosForm.est_sigla || !dadosForm.log_logradouro || !dadosForm.pee_numero || !dadosForm.bai_nome) {
                notification.warning({ message: 'Atenção!', description: 'Para clientes com CNPJ é necessário informar os dados de endereço' });
                return;
            }
        }

        let dadosTemp = {
            pes_nome: dadosForm.pes_nome || 'CONSUMIDOR FINAL',
            cpfCnpj: dadosForm.cpfCnpj || ''
        };

        const campos = ['pej_inscricaoestadual', 'cep_cep', 'cid_descricao', 'est_sigla', 'log_logradouro', 'pee_numero', 'bai_nome'];
        campos.forEach(campo => {
            if (dadosForm[campo]) {
                dadosTemp[campo] = dadosForm[campo];
            }
        });

        let copiaDadosTemp = Object.keys(dadosTempCliente).length > 0 ? {
            ...dadosTempCliente,
            dadosForm: [dadosTemp]
        } : {
            ...dadosTemp,
            dadosForm: [dadosTemp]
        };

        if (dadosForm.cpfCnpj.length > 14) {
            if (!dadosForm.pej_inscricaoestadual) {
                const confirmou = await confirmarContinuacao();
                if (!confirmou) return;
            }
        }

        dispatch({ type: manutencaoActions.CHANGE, data: { dados: { ...manutencao.dados, ...{ cliente: copiaDadosTemp } } } });
        setDadosCliente(copiaDadosTemp);
        form.resetFields();
        fecharModalBuscaCliente();
        if (consultaCliente) setConsultaCliente(false);
    }

    function confirmarContinuacao() {
        return new Promise((resolve) => {
            Modal.confirm({
                title: 'Atenção!',
                content: (
                    <>
                        <span>
                            CNPJ sem Inscrição Estadual!<br />
                            Caso o cliente seja contribuinte de ICMS e a IE não seja informada, a NF-e poderá ser rejeitada.<br />
                            Confirme se o cliente é ISENTO ou NÂO CONTRIBUINTE antes de continuar.
                        </span>
                    </>
                ),
                okText: 'Continuar',
                cancelText: 'Cancelar',
                onOk: () => resolve(true),
                onCancel: () => resolve(false),
            });
        });
    }

    return (
        <Modal centered
            title={<span><UserOutlined /> Cliente</span>}
            open={exibirModalBuscaCliente}
            getContainer={false}
            maskClosable={false}
            onCancel={() => onCloseModal()}
            keyboard={true}
            width={950}
            styles={{ body: { padding: '0 15px' } }}
            footer={[
                <Row justify="space-between" style={{ borderTop: '1px solid', borderTopColor: '#dfdfdf' }}>
                    {!consultaCliente ? (
                        <>
                            <Col>
                                <Button icon={<SearchOutlined />} className="m-l-6 m-t-6" onClick={() => { buscarCliente() }}                                >
                                    Buscar Cliente
                                </Button>
                            </Col>
                            <Col>
                                <Row gutter={[4, 0]}>
                                    <Col>
                                        <Button className="m-t-6" onClick={() => onCloseModal()} style={{ display: 'block' }}>Cancelar <span style={{ fontSize: '10px' }}>(Esc)</span></Button>
                                    </Col>
                                    <Col>
                                        <Button className="m-t-6" type="primary" onClick={() => { adicionarCliente() }} style={{ display: 'block' }}>Ok <span style={{ fontSize: '10px' }}>(Enter)</span></Button>
                                    </Col>
                                </Row>
                            </Col>
                        </>
                    ) : (
                        <>
                            <Col>
                                <Button className="m-l-6 m-t-6" icon={<ArrowLeftOutlined />} onClick={() => setConsultaCliente(false)}> Voltar </Button>
                            </Col>
                            <Col>
                                <Button className="m-t-6" type="primary" icon={<PlusOutlined />} onClick={() => {
                                    setConsultaCliente(false);
                                    // fecharModalBuscaCliente();
                                    dispatch({ type: drawerActions.CHANGE, data: { showDrawer: true } });
                                }}>
                                    Cadastrar Cliente
                                </Button>
                            </Col>
                        </>
                    )}
                </Row>
            ]}
        >
            <div className="col-modal">
                {!consultaCliente === true &&
                    <>
                        <Spin spinning={carregandoBusca}>
                            <Form layout="vertical" name="buscarCliente" form={form}>
                                <Row gutter={[8, 0]} className="m-b-10">
                                    <Col xs={24} sm={6} md={6} lg={6} xl={6} xxl={5}>
                                        <Form.Item label="CPF/CNPJ" name="cpfCnpj">
                                            <CpfCnpj
                                                className='inputCpfCnpj'
                                                placeholder="Informe o CPF ou CNPJ"
                                                id="cpf"
                                                value={cpfCnpj}
                                                onBlur={() => { buscarClienteCpfCnpj() }}
                                                onChange={(event, type) => {
                                                    setCpfCnpj(event.target.value);
                                                }} />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={11} md={12} lg={12} xl={12} xxl={19}>
                                        <Form.Item label="Nome" name="pes_nome">
                                            <Input placeholder="Informe o Nome" />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Divider orientation="left" plain>
                                    Dados do Endereço{' '} {cpfCnpj?.length > 14 && (<small style={{ color: 'red' }}>* (Obrigatório para CNPJ)</small>)}
                                </Divider>
                                <Row gutter={[8, 0]}>
                                    <Col xs={24} sm={8} md={6} lg={6} xl={6} xxl={6}>
                                        <Form.Item label="IE" name="pej_inscricaoestadual" rules={[{ required: cpfCnpj?.length > 14 ? true : false }]}>
                                            <Input placeholder="Informe a Inscrição Estadual" />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={6} md={4} lg={4} xl={3} xxl={4}>
                                        <InputCep
                                            label="CEP"
                                            name="cep_cep"
                                            placeholder='Informe o CEP'
                                            onBlur={(cep) => verificaCep(cep.currentTarget.value)}
                                            onPressEnter={(cep) => verificaCep(cep.currentTarget.value)}
                                        />
                                    </Col>
                                    <Col xs={24} sm={6} md={3} lg={3} xl={4}>
                                        <Form.Item className="text-center t-mob-573">
                                            <Typography.Link href="http://www.buscacep.correios.com.br/sistemas/buscacep/" target="_black" underline>
                                                Não sei o CEP
                                            </Typography.Link>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={12} md={6} lg={4} xl={8}>
                                        <Form.Item label="Cidade" name="cid_descricao">
                                            <Input disabled />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={6} sm={2} md={2} lg={2} xl={2} xxl={2}>
                                        <Form.Item label="UF" name="est_sigla">
                                            <Input disabled />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={19} md={10} lg={10} xl={10} xxl={13}>
                                        <Form.Item label="Endereco" name="log_logradouro">
                                            <Input placeholder="Informe o Endereço" />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={5} md={4} lg={3} xl={3} xxl={5}>
                                        <Form.Item label="Número" name="pee_numero">
                                            <Input placeholder="Informe o Número" />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={8} md={5} lg={4} xl={4} xxl={6}>
                                        <Form.Item label="Bairro" name="bai_nome">
                                            <Input placeholder="Informe o Bairro" />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Spin>
                    </>
                }
                {!consultaCliente === false &&
                    <>
                        <Form layout="vertical" name="manutencaoBuscarCliente" form={form}>
                            <Row>
                                <Col xs={23} sm={23} md={23} lg={23} xl={10} xxl={24}>
                                    <Form.Item label="Localizar" name="pesquisa">
                                        <Input.Search placeholder="Pesquisa por Cliente... (Nome, CPF, CNPJ)" onSearch={valor => { dispararPesquisa(valor) }} allowClear />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row align="middle" className="tabela">
                                <TabelaDados url="Cliente/Listar" colunas={
                                    [
                                        {
                                            title: 'CPF/CNPJ',
                                            width: '25%',
                                            render: ({ pej_cnpj, pef_cpf }) => (
                                                <div>
                                                    <Row align="left" justify="left">
                                                        <Col>
                                                            {!!pef_cpf ? MaskFormat(pef_cpf, 'Não Informado', true) : !!pej_cnpj ? MaskFormat(pej_cnpj, 'Não Informado', true) : 'Não Informado'}
                                                        </Col>
                                                    </Row>
                                                </div>
                                            ),
                                        },
                                        {
                                            title: 'Cliente',
                                            width: '55%',
                                            render: ({ pes_nome }) => (
                                                <div>
                                                    <Row>
                                                        <Col>
                                                            {pes_nome}
                                                        </Col>
                                                    </Row>
                                                </div>
                                            ),
                                        },
                                        {
                                            title: 'Ações',
                                            dataIndex: '',
                                            align: 'right',
                                            key: 'x',
                                            width: '20%',
                                            render: (record) => (
                                                <div>
                                                    <Button onClick={() => selecionarCliente(record)} type="primary">
                                                        Selecionar <ArrowRightOutlined />
                                                    </Button>
                                                </div>
                                            ),
                                        },
                                    ]} scroll={{ y: 400 }}
                                />
                            </Row>
                        </Form>
                    </>
                }
            </div>
            <DrawerCliente editando={editando} setEditando={setEditando} adicionarCliente={buscarClienteId} />
        </Modal>
    );
}